__webpack_require__.p = "/Shopping-Mart/";